export const brandAssets = {
  logo: '/kaamco-logo.svg',
  publicLogo: '/kaamco-logo.svg',
  absoluteLogo: 'https://kaamco.com/kaamco-logo.svg',
} as const
